import * as reportsCenterService from "./service";
export default {
    api: {
        reportsCenterService: reportsCenterService
    }
};

//# sourceMappingURL=index.js.map